// extracted by mini-css-extract-plugin
export default {"feed":"FeedPhotos_feed__3i4-i"};